import React from 'react'
import mainLogo from '../img/mainLogo.svg'
import hippa_logo from '../img/hippa_logo.png'
import linkedIcon from '../img/LinkedIn.svg'

const Footer = () => {
    const webLinked = () => {
      };
    return (
        <div className='footerWrap'>
            <div class="container">
                <div class="mainLogo">
                    <img src={mainLogo} alt='' />
                </div>
                <div class="hippalogo">
                    <img src={hippa_logo} alt='' />
                </div>
                <ul>
                    <li>
                        <p class="comText">@2026 by Epilog Ltd</p>
                    </li>
                    <li>
                        <a href='https://www.linkedin.com/company/epilog-world/' target='_blank' rel='noreferrer' onClick={webLinked}><img src={linkedIcon} alt='' /></a>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Footer
